export default __webpack_public_path__ + "a9027cb94f9b29cffb5310ba57f28d19.svg";